// 彩種類型名稱對應
const lotteryTypeNameMapping = {
  syx5: '11选5',
  k3: '快3',
  kl8: '快乐8',
  pk10: 'PK10',
  xy28: '幸运28',
  normal: '一般彩票',
  ssc: '时时彩',
  kl10: '快乐十分',
  sixhc: '六合彩'
}

export {
  lotteryTypeNameMapping
}
